import * as React from 'react'

const SvgGeoCubeIcon = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_3890_88220)">
      <path
        d="M19.995 4.06385C19.995 3.81807 19.8513 3.5999 19.6355 3.49868C19.5692 3.46756 8.93253 0.030907 8.92183 0.027822C8.79371 -0.00931428 8.65438 -0.00576075 8.52438 0.044301C-0.180359 3.39169 0.364815 3.17594 0.283357 3.22939C0.146956 3.31901 0.0539003 3.45678 0.0182088 3.60829C-0.0110394 3.73177 0.00348707 15.9827 0.00446331 15.9932C0.0214109 16.1773 0.124073 16.3523 0.27953 16.4543C0.383012 16.5238 -0.243267 16.3103 11.0555 19.9658C11.1284 19.9896 11.2124 20.001 11.2983 19.994C11.4343 19.983 10.9443 20.1575 19.5945 16.8305C19.7338 16.777 19.8655 16.6652 19.9368 16.5097C20.0253 16.3185 19.995 17.1397 19.995 4.06385ZM2.49896 3.70061L8.76664 1.28995L17.4975 4.11465L11.2299 6.52531L2.49896 3.70061ZM11.8726 7.61695L18.7454 4.97359V15.8183L11.8726 18.4617V7.61695ZM1.25109 15.4804V4.61027L8.13537 6.83755C8.22807 7.32126 8.81835 7.51034 9.176 7.17424L10.623 7.64241V12.9265C10.1226 13.1454 10.1261 13.8546 10.623 14.0708V18.5125L1.25109 15.4804Z"
        fill="white"
      />
      <path
        d="M15.314 14.2786C14.986 14.1723 14.6338 14.3524 14.5276 14.6804C14.4214 15.0088 14.6014 15.361 14.9294 15.4672C15.2553 15.5725 15.6093 15.3962 15.7163 15.0654C15.8225 14.737 15.6424 14.3848 15.314 14.2786Z"
        fill="white"
      />
      <path
        d="M13.189 13.5911C12.861 13.4848 12.5088 13.6649 12.4026 13.9929C12.2964 14.3213 12.4764 14.6735 12.8044 14.7797C13.1328 14.8858 13.485 14.7066 13.5913 14.3775C13.6975 14.0495 13.5174 13.6972 13.189 13.5911Z"
        fill="white"
      />
      <path
        d="M17.4385 14.9661C17.11 14.8598 16.7578 15.0399 16.6516 15.3683C16.5454 15.6963 16.7254 16.0485 17.0534 16.1547C17.3822 16.2609 17.7342 16.081 17.8403 15.7525C17.9465 15.4245 17.7665 15.0723 17.4385 14.9661Z"
        fill="white"
      />
      <path
        d="M8.74882 11.4049C9.09389 11.4049 9.37362 11.1251 9.37362 10.7801C9.37362 10.435 9.09389 10.1553 8.74882 10.1553C8.40375 10.1553 8.12402 10.435 8.12402 10.7801C8.12402 11.1251 8.40375 11.4049 8.74882 11.4049Z"
        fill="white"
      />
      <path
        d="M8.74882 9.37459C9.09389 9.37459 9.37362 9.09486 9.37362 8.7498C9.37362 8.40473 9.09389 8.125 8.74882 8.125C8.40375 8.125 8.12402 8.40473 8.12402 8.7498C8.12402 9.09486 8.40375 9.37459 8.74882 9.37459Z"
        fill="white"
      />
      <path
        d="M8.74882 5.31307C9.09389 5.31307 9.37362 5.03334 9.37362 4.68827C9.37362 4.34321 9.09389 4.06348 8.74882 4.06348C8.40375 4.06348 8.12402 4.34321 8.12402 4.68827C8.12402 5.03334 8.40375 5.31307 8.74882 5.31307Z"
        fill="white"
      />
      <path
        d="M8.74882 3.2828C9.09389 3.2828 9.37362 3.00306 9.37362 2.658C9.37362 2.31293 9.09389 2.0332 8.74882 2.0332C8.40375 2.0332 8.12402 2.31293 8.12402 2.658C8.12402 3.00306 8.40375 3.2828 8.74882 3.2828Z"
        fill="white"
      />
      <path
        d="M4.46332 13.79C4.14116 13.9138 3.98027 14.2754 4.10445 14.5972C4.19973 14.8455 4.43637 14.9978 4.68746 14.9978C5.12291 14.9978 5.42847 14.5596 5.27048 14.1489C5.14669 13.8267 4.78509 13.6658 4.46332 13.79Z"
        fill="white"
      />
      <path
        d="M2.43304 14.5713C2.11088 14.6951 1.95 15.0567 2.07418 15.3784C2.16946 15.6268 2.4061 15.7791 2.65719 15.7791C3.09263 15.7791 3.3982 15.3409 3.2402 14.9301C3.11641 14.608 2.75481 14.447 2.43304 14.5713Z"
        fill="white"
      />
      <path
        d="M6.49359 13.0088C6.17143 13.1326 6.01055 13.4942 6.13472 13.8159C6.23 14.0643 6.46704 14.2166 6.71774 14.2166C7.15318 14.2166 7.45874 13.7784 7.30075 13.3676C7.17696 13.0455 6.81536 12.8845 6.49359 13.0088Z"
        fill="white"
      />
      <path
        d="M9.36106 12.6886C9.27917 12.3083 8.90851 12.1109 8.56678 12.2134C8.23224 12.3161 8.05238 12.6638 8.1509 12.9924C8.25142 13.3208 8.59568 13.5085 8.92995 13.4083C9.2375 13.3142 9.4224 13.0069 9.36106 12.6886Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_3890_88220">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default SvgGeoCubeIcon
